export const formatConnectionLabel = (
  noOfConnections: number | null | undefined,
  isProUser?: boolean,
) => {
  if (!noOfConnections) {
    return isProUser ? 'No associated pathways' : 'No connections';
  }
  return isProUser
    ? `${noOfConnections} associated pathway${noOfConnections > 1 ? 's' : ''}`
    : `${noOfConnections} connections`;
};
